var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2244 24.9032C33.5135 24.8088 32.2648 23.5265 32.1741 21.8155C32.1191 20.7785 32.0747 19.3978 32.0646 17.5868C22.6753 17.7017 16.2934 18.0774 12.2964 18.4175C8.93227 18.7035 6.35139 21.1183 6.028 24.4791C5.67719 28.1248 5.34375 33.9216 5.34375 42.786C5.34375 51.6504 5.67719 57.4472 6.028 61.093C6.35139 64.4537 8.93226 66.8684 12.2964 67.1546C17.0848 67.5619 25.296 68.0204 38 68.0204C50.704 68.0204 58.9153 67.5619 63.7036 67.1546C67.0678 66.8684 69.6487 64.4537 69.972 61.093C70.3229 57.4472 70.6563 51.6504 70.6563 42.786C70.6563 33.9216 70.3229 28.1248 69.972 24.4791C69.6487 21.1183 67.0678 18.7035 63.7036 18.4175C59.7066 18.0774 53.3247 17.7017 43.9354 17.5868C43.9253 19.3978 43.8809 20.7785 43.8259 21.8155C43.7352 23.5265 42.4865 24.8088 40.7756 24.9032C40.0225 24.9447 39.1026 24.9735 38 24.9735C36.8974 24.9735 35.9775 24.9447 35.2244 24.9032Z",
    stroke: "#E5E7EB",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1575 45.8562C34.3382 44.3905 35.7731 41.9006 35.7731 39.0755C35.7731 34.5666 32.1179 30.9115 27.6091 30.9115C23.1001 30.9115 19.445 34.5666 19.445 39.0755C19.445 41.9004 20.8797 44.3902 23.0604 45.856C19.4043 47.2861 16.6703 50.4392 15.9321 54.5696C15.6952 55.8956 16.6512 57.047 17.9896 57.1996C19.8139 57.4079 22.8712 57.6302 27.6088 57.6302C32.3462 57.6302 35.4035 57.4079 37.2278 57.1996C38.5661 57.047 39.5222 55.8956 39.2853 54.5696C38.5471 50.4393 35.8134 47.2862 32.1575 45.8562Z",
    stroke: "#E5E7EB",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3906 53.1771H60.2656",
    stroke: "#E5E7EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3906 44.2708H60.2656",
    stroke: "#E5E7EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3906 35.3646H60.2656",
    stroke: "#E5E7EB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1741 21.816C32.2648 23.527 33.5135 24.8092 35.2242 24.9036C35.9775 24.9452 36.8974 24.974 38 24.974C39.1026 24.974 40.0225 24.9452 40.7756 24.9036C42.4865 24.8092 43.7352 23.527 43.8259 21.816C43.8885 20.6354 43.9375 19.0092 43.9375 16.8099C43.9375 14.6106 43.8885 12.9844 43.8259 11.8038C43.7352 10.0928 42.4865 8.81055 40.7756 8.71619C40.0225 8.67464 39.1026 8.64584 38 8.64584C36.8974 8.64584 35.9775 8.67464 35.2244 8.71619C33.5135 8.81055 32.2648 10.0928 32.1741 11.8038C32.1115 12.9844 32.0625 14.6106 32.0625 16.8099C32.0625 19.0092 32.1115 20.6354 32.1741 21.816Z",
    stroke: "#E5E7EB",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlProfileIcon);
export default __webpack_public_path__ + "static/media/controlProfileIcon.bae71a15f923578b4818576aa38879a5.svg";
export { ForwardRef as ReactComponent };